module.exports = __webpack_public_path__ + "static/media/product-rafa-detail.10a89a74.png";